import { useMutation } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import { stopCampaign } from '../../services/marketing';

interface Options {
  onSuccess?: () => void;
  onError?: () => void;
  onMutate?: () => void;
  onSettled?: () => void;
}

function useStopCampaign({
  onSuccess,
  onError,
  onMutate,
  onSettled,
}: Options = {}) {
  const { data, isFetching, refetch } = useGetMarketingData();

  return useMutation({
    mutationFn: async (campaignId: string) => {
      if (!data?.id || isFetching) return null;

      const result = await stopCampaign(data?.id, campaignId);
      return result;
    },
    onSuccess: async () => {
      await refetch();
      if (onSuccess) onSuccess();
    },
    onError,
    onMutate,
    onSettled,
  });
}

export default useStopCampaign;
